module.exports = __webpack_public_path__ + "static/media/Dagim4.a6b75f7d.png";